import { z } from 'zod';
export const addressSchema = z.object({
    street: z.string().min(1).describe('The street line, with the number, such as 412 Alder Street.'),
    city: z.string().min(1).describe('The city.'),
    state: z.string().min(1).describe('The state or region, such as CA.'),
    zipCode: z.string().min(1).describe('The ZIP or postal code.'),
    country: z.string().min(1).describe('The country, such as United States.'),
});
export const partialAddressSchema = z.object({
    street: z.string().min(1).optional(),
    city: z.string().min(1).optional(),
    state: z.string().min(1).optional(),
    zipCode: z.string().min(1).optional(),
    country: z.string().min(1).optional(),
});
//# sourceMappingURL=common.js.map